const names = {
	USER: "USER",
	ADMIN: "ADMIN",
	SUPER: "SUPER_ADMIN"
};

const types = [
	{
		id: 3,
		code: names.USER,
		name: "utente",
	},
	{
		id: 2,
		code: names.ADMIN,
		name: "amministratore",
	},
	{
		id: 1,
		code: names.SUPER,
		name: "superutente",
	},
];

let isSuperUser = user => user.role.name === names.SUPER;

let isAdmin = user => user.role.name === names.ADMIN || isSuperUser(user);


export default {names, types, isAdmin, isSuperUser}